import { useState, useCallback } from 'react';

import { fetchFnsLookupByInn } from 'APIPackage/FnsModule/services/fnsLookupApi';

export function useFnsLookupByInn() {
  const [isLoading, setIsLoading] = useState(false);

  const getFnsLookupByInn = useCallback(async (inn: string) => {
    try {
      setIsLoading(true);
      const response = await fetchFnsLookupByInn(inn);

      return {
        success: true,
        data: response,
      };
    } catch (err) {
      return {
        success: false,
      };
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    isLoading,
    getFnsLookupByInn,
  };
}
